import React, { Fragment } from "react";
import { Helper } from "../../services";
import { type IRow } from "./types";

function View(props: IRow) {
    const { data } = props;
    return (
        <>
            <h5 className="tab-pane__title">Dermatologist Information</h5>
            <div className="row info-table">
                <>
                    {Object.entries(data).map(([item, value], index) =>
                        value && item === "location" ? (
                            <Fragment key={index}>
                                {Helper.strToArray(value).map((value, index) => (
                                    <div className="col-lg-6" key={index}>
                                        <div className="row" key={index}>
                                            <div className="col-4">
                                                {index === 1 ? "Latitude" : "Longitude"}
                                            </div>
                                            <div className="col-8">
                                                :<strong className="ml-2">{value}</strong>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </Fragment>
                        ) : value && item !== "id" && item !== "createdAt" ? (
                            <div className="col-lg-6" key={index}>
                                <div className="row">
                                    <div className="col-4">
                                        {item.charAt(0).toUpperCase() +
                                            item.slice(1).replace(/([a-z])([A-Z])/g, "$1 $2")}
                                    </div>
                                    <div className="col-8 d-flex">
                                        <>
                                            :
                                            <strong className="ml-2">
                                                {Array.isArray(value) && item !== "language"
                                                    ? value.map((val, index) => (
                                                          <span
                                                              key={index}
                                                              className="alert alert--customize border-0 px-3"
                                                          >
                                                              {val}
                                                          </span>
                                                      ))
                                                    : item === "gender"
                                                      ? Helper.GetGender(value)
                                                      : value}
                                            </strong>
                                        </>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            ""
                        )
                    )}
                </>
            </div>
        </>
    );
}

export default View;
